module.exports = {
  // General
  lang: {
    zh: '简体中文',
    'zh-TW': '繁體中文',
    en: 'English'
  },
  
  // Top Navigation
  nav: {
    aboutUs: 'About Us',
    society: 'Corporate Social Responsibility',
    news: 'News',
    investor: 'Investor Relations',
    joinUs: 'Join Us'
  },
  
  // Investor Relations
  investor: {
    banner: {
      ch: 'Investor Relations',
      en: 'Investor Relations'
    },
    tabs: {
      report: 'Announcements & Press Releases',
      finReport: 'Financial Reports',
      court: 'Board of Directors',
      company: 'Company Information',
      telMeeting: 'Investor Activities',
      analyst: 'Analysts',
      businessFile: 'Corporate Governance',
      contactUs: 'Contact Us',
      faq: 'FAQ',
      investorEn: 'Investor Relations'
    },
    // Announcements & Press Releases
    report: {
      notice: 'Corporate communications can be accessed on the Company\'s website (<a href="www.kingsoft.com" target="_blank">www.kingsoft.com</a>) and the Hong Kong Exchanges and Clearing Limited website (<a href="www.hkexnews.hk" target="_blank">www.hkexnews.hk</a>). Actionable corporate communications* will be sent individually to registered shareholders via the email address provided or in printed form.<br><br>If you require a printed copy of corporate communications, you may submit your request by sending an email to the share registrar, Hong Kong Registrars Limited, at <a href="mailto:kingsoft.ecom@computershare.com.hk">kingsoft.ecom@computershare.com.hk</a>.<br><br>If you wish to choose/change the way you receive corporate communications, and/or provide/change your electronic contact information, please contact the share registrar, Hong Kong Registrars Limited (for registered shareholders) or the bank, broker, custodian, nominee or HKSCC Nominees Limited through which you hold your shares (for non-registered shareholders).',
      noticeFoot: '* Actionable corporate communications refer to any corporate communications that involve requesting the Company\'s securities holders to indicate how they wish to exercise their rights or make choices regarding their securities.',
      title: 'Announcements & Press Releases',
      tabs: {
        announcement: 'Announcements',
        news: 'Press Releases'
      },
      yearPlaceholder: 'Select Year',
      noData: 'No data available'
    },
    // Financial Reports
    finReport: {
      title: 'Financial Reports',
      year: 'Year',
      interim: 'Interim Report',
      annual: 'Annual Report',
      quarterly: 'Quarterly Report'
    },
    // Board of Directors
    court: {
      title: 'Board of Directors',
      chairman: 'Chairman',
      member: 'Board Member',
      independent: 'Independent Non-Executive Director',
      directors: [
        {
          name: 'Lei Jun',
          title: 'Chairman and Non-Executive Director',
          intro: 'Lei Jun, aged 56, is a non-executive Director, the Chairman of the Board, the chairman of the Nomination Committee, a member of the Remuneration Committee and a co-founder of the Company. Mr. Lei has been employed by the Company since 1992 and has played an important role in the development and expansion of the Group\'s business operations. He served as the chief executive officer of the Group from 1998, under his leadership the Group further expanded from application software business to utility software, internet security software and online games. He also played an important role in transforming the Group from a traditional software company to a software company that widely uses the internet to provide services according to customer needs. Mr. Lei resigned as chief executive officer, chief technology officer and president in December 2007, and was re-designated from executive director to non-executive director in August 2008. Mr. Lei was appointed as the Chairman of the Board on July 5, 2011. Mr. Lei is also a director of certain subsidiaries of the Company.',
          detail: 'Mr. Lei co-founded Xiaomi Corporation (listed on the Stock Exchange in July 2018, stock code: 1810) with other partners in 2010, and currently serves as executive director, chairman, chief executive officer and member of the Remuneration Committee. Since December 2011, Mr. Lei has been a director of Kingsoft Office (SSE STAR Market: 688111). From April 2015 to March 2026, Mr. Lei served as chairman of Kingsoft Cloud (a company listed on the Stock Exchange, stock code: 03896 and NASDAQ: KC).\n\nMr. Lei graduated from the Computer Science Department of Wuhan University in July 1991 with a Bachelor of Science degree. He has been a member of the Board of Wuhan University since 2003.\n\nMr. Lei is also an active angel investor in China.'
        },
        {
          name: 'Zou Tao',
          title: 'Executive Director and Chief Executive Officer',
          intro: 'Zou Tao, aged 50, is currently an executive Director, the chief executive officer ("CEO") and a member of the environmental, social and governance committee of the Company. Mr. Zou currently serves as a director and acting CEO of Seasun, the chairman of Kingsoft Office (SSE STAR Market: 688111) and the chairman and acting CEO of Kingsoft Cloud (a company listed on the Stock Exchange, stock code: 03896 and NASDAQ: KC). From December 1, 2016 to April 2, 2020, Mr. Zou served as a director of Xunlei Limited (NASDAQ: XNET), from December 1, 2016 to December 14, 2020 as a director of 21Vianet Group (NASDAQ: VNET), and from December 1, 2016 to June 30, 2024 as a director of Cheetah Mobile (NYSE: CMCM). Mr. Zou graduated from Nankai University in 1997. Mr. Zou joined the Company in 1998 and was responsible for developing the Group\'s Kingsoft Ciba products. Mr. Zou has been responsible for the Group\'s entertainment software business since 2004 and served as the CEO of Seasun until January 2018. Since 2022, Mr. Zou has been the acting CEO of Kingsoft Cloud. Since December 2025, Mr. Zou has been the acting CEO of Seasun. Since March 2026, Mr. Zou has been the chairman of Kingsoft Cloud.',
          detail: 'Mr. Zou became a senior vice president of the Company in December 2007, has been an executive director of the Company since August 2009, and has been the CEO of the Company since December 2016.\n\nMr. Zou is also a director of certain subsidiaries of the Company.'
        },
        {
          name: 'Qiu Bojun',
          title: 'Non-Executive Director',
          intro: 'Qiu Bojun, aged 61, was re-designated from an executive director to a non-executive director on October 24, 2011. Mr. Qiu currently serves as a director of Kingsoft Office (SSE STAR Market: 688111). Mr. Qiu has been employed by the Company since 1988. He graduated from the National University of Defense Technology in China in 1984 with a bachelor\'s degree in information management systems. From 1984 to 1987, Mr. Qiu worked as a software developer in several Chinese companies.',
          detail: 'Mr. Qiu founded Kingsoft in 1988 and was dedicated to developing WPS 1.0. Mr. Qiu was selected as one of the Top Ten Economic Figures of the Year by China Central Television in 2000, was selected as the Financial Figure of the Year in 2001, was selected as one of the ten most influential leaders in China\'s gaming industry at the inauguration ceremony of the China Gaming Industry Annual Conference in January 2005, and was selected as Outstanding Entrepreneur of the Year 2009 in China\'s gaming industry at the China Gaming Industry Annual Conference in December 2009. Mr. Qiu was appointed as the acting CEO of the Company in December 2007, served as the CEO of the Company from May 2008, and resigned on October 24, 2011. Before July 5, 2011, Mr. Qiu served as the Chairman of the Board.\n\nMr. Qiu is also a director of certain subsidiaries of the Company.'
        }
      ]
    },
    // Company Information
    company: {
      title: 'Company Overview',
      hkAddress: {
        title: 'Hong Kong Principal Office',
        addressLabel: 'Address:',
        address1: 'Harbour City, Tsim Sha Tsui, Kowloon, Hong Kong',
        address2: 'Suite 3208, 32/F, Tower 5, Gateway',
        phoneLabel: 'Tel:',
        phone1: '(852) 98303138 (Mobile)',
        phone2: '(852) 24050088 (Landline)'
      },
      market: {
        title: 'Market Information',
        exchange: 'Exchange: HKEX',
        listingDate: 'Listing Date: October 9, 2007',
        stockCode: 'Stock Code: 3888'
      },
      auditor: {
        title: 'Auditor',
        name: 'Ernst & Young (Registered Public Interest Entity Auditor)',
        address1: 'Quarry Bay, Hong Kong',
        address2: '979 King\'s Road',
        address3: '27/F, One Taikoo Place'
      },
      audit: {
        title: 'Audit Committee',
        members: ['Ms. Wu Wenjie (Chairperson)', 'Mr. Chen Zuotao', 'Mr. Du Bo']
      },
      remuneration: {
        title: 'Remuneration Committee',
        members: ['Mr. Chen Zuotao (Chairman)', 'Mr. Lei Jun', 'Ms. Wu Wenjie', 'Mr. Du Bo']
      },
      nomination: {
        title: 'Nomination Committee',
        members: ['Mr. Lei Jun (Chairman)', 'Mr. Yao Leiwen', 'Ms. Wu Wenjie', 'Mr. Chen Zuotao', 'Mr. Du Bo']
      },
      esg: {
        title: 'Environmental, Social and Governance Committee',
        members: ['Mr. Chen Zuotao (Chairman)', 'Mr. Zou Tao', 'Ms. Wu Wenjie', 'Mr. Du Bo']
      }
    },
    // Investor Activities
    telMeeting: {
      title: 'Investor Activities',
      webcast: 'Webcast',
      date: 'Date',
      time: 'Time',
      download: 'Download',
      playback: 'Playback'
    },
    // Analysts
    analyst: {
      title: 'Analysts',
      name: 'Name',
      institution: 'Institution',
      contact: 'Contact'
    },
    // Corporate Governance
    businessFile: {
      title: 'Corporate Governance',
      fileName: 'File Name',
      date: 'Date',
      download: 'Download'
    },
    // Contact Us
    contactUs: {
      title: 'Contact Us',
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      message: 'Message',
      submit: 'Submit',
      followUs: 'Follow Us'
    },
    // FAQ
    faq: {
      title: 'FAQ',
      question: 'Question',
      answer: 'Answer',
      questions: [
        {
          q: 'Where is Kingsoft Corporation Limited located?',
          a: 'Kingsoft Corporation Limited is headquartered in Hong Kong, with R&D centers in Beijing, Zhuhai, Wuhan, Chengdu, Dalian, and Hong Kong.\n\nHong Kong Office:\nSuite 3208, 32/F, Tower 5, Gateway Harbour City, Tsim Sha Tsui, Kowloon, Hong Kong\nTel: (852) 98303138 (Mobile)\n(852) 24050088 (Landline)\n\nBeijing Office:\nBuilding D, Xiaomi Science and Technology Park, No. 33 West Erqi Road, Haidian District, Beijing\nPostal Code: 100085\nTel: 8610 82335515\nFax: 8610 82325655'
        },
        {
          q: 'Where is Kingsoft Corporation Limited listed?',
          a: 'The company is listed on the Hong Kong Stock Exchange with stock code 3888.'
        },
        {
          q: 'When did Kingsoft Corporation Limited have its IPO?',
          a: 'October 9, 2007.'
        },
        {
          q: 'When does Kingsoft Corporation Limited\'s fiscal year end?',
          a: 'December 31 of each year.'
        },
        {
          q: 'Who is Kingsoft Corporation Limited\'s independent auditor?',
          a: 'Ernst & Young Hong Kong.'
        },
        {
          q: 'Who is Kingsoft Corporation Limited\'s Hong Kong legal compliance advisor?',
          a: 'Baker McKenzie.'
        }
      ]
    }
  },

  // Corporate Social Responsibility
  society: {
    banner: {
      ch: 'Sustainable Development Of Technology',
      en: 'Sustainable Development Of Technology'
    },
    tabs: {
      report: 'Environmental, Social and Governance Report',
      esg: 'ESG Ratings & Awards',
      foundation: 'Public Welfare Foundation'
    },
    report: {
      title: 'Environmental, Social and Governance Report',
      yearlyTitle: 'Annual Reports',
      chairman: {
        title: "Chairman's Message",
        para1: 'In 2025, the iteration and large-scale application of AI technology have accelerated significantly, continuously reshaping the industrial ecosystem. The integration of the digital economy and the real economy has entered a new phase of comprehensive, in-depth development, with the industry finding new opportunities amid transformation and achieving upgrades through adjustment. Over 37 years of unwavering commitment, Kingsoft has steadfastly pursued "technology as the foundation" as its core direction, driving breakthroughs through innovation, continuously increasing R&D investment, and steadily cultivating strengths in office software, gaming products and services. We continue to deeply integrate ESG principles into every aspect of our corporate development strategy, operational management, business innovation, and value creation, driving long-term value for the company. Facing the wave of large-scale AI applications, we adhere to the philosophy of "Technology for Good, Symbiotic Prosperity", comprehensively deepening ESG practices across regulatory compliance, service quality improvement, low-carbon action, public welfare empowerment, talent development, and ecosystem co-building, fulfilling the mission and responsibility of a technology enterprise through concrete actions, and contributing to high-quality industry development.',
        para2: 'Our founding spirit endures, and our journey continues. Looking ahead, Kingsoft will continue to build on technology as its foundation and ESG principles as its compass, integrating responsibility and commitment into every innovation and every service. With a more open approach, we will work hand in hand with all stakeholders to contribute the steadfast "Kingsoft Force" to high-quality industry development and a sustainable future for society.',
        name: 'Lei Jun',
        position: 'Chairman of the Board'
      }
    },
    esg: {
      title: 'ESG Ratings & Awards',
      ratings: [
        { label: 'MSCI', scores: ['AA (2025)', 'AA (2024)', 'BBB (2023)'] },
        { label: 'S&P ESG Score', scores: ['63 (2025)', '54 (2024)', '43 (2023)'] }
      ],
      awards: [
        { file: 'Member of the S&P Global Sustainability Yearbook 2026.pdf', name: 'Selected for S&P Global Sustainability Yearbook 2026 (Global Edition)' },
        { file: 'Global-CSA-Score-Chinese-Corporate.pdf', name: 'Awarded "Top 1% of Chinese Companies in S&P Global CSA Score"' },
        { file: '标普全球《可持续发展年鉴2025（全球版）》.pdf', name: 'Selected for S&P Global Sustainability Yearbook 2025 (Global Edition)' },
        { file: '标普全球"行业最佳进步企业"表彰.pdf', name: 'Awarded S&P Global "Industry Mover" Recognition' },
        { file: '入选标普《可持续发展年鉴（中国版）2024》.pdf', name: 'Selected for S&P Global Sustainability Yearbook (China Edition) 2024' },
        { file: '金山软件-上市公司可持续优秀实践案例证书.pdf', name: 'Selected as Outstanding Sustainable Development Practice Case by China Association for Public Companies (2025)' },
        { file: '入选中国上市公司协会2024年上市公司可持续发展优秀实践案例.pdf', name: 'Selected as Outstanding Sustainable Development Practice Case by China Association for Public Companies (2024)' },
        { file: '金山软件-上市公司ESG优秀实践案例证书.pdf', name: 'Selected as Outstanding ESG Practice Case by China Association for Public Companies (2023)' }
      ]
    }
  },

  // Footer
  footer: {
    copyright: '© 2024 Kingsoft Corporation Limited',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    contact: 'Contact Us',
    followUs: 'Follow Us',
    backToTop: 'Back to Top'
  }
}
